import type { PersistedState } from 'redux-persist';

import { ESlice } from '@enums/redux.enum';
import type { RootReducerState } from '@store/rootReducer';

export const migrateV1 = (state: PersistedState) => {
	const prevState = state as PersistedState & Partial<RootReducerState>;

	return {
		...prevState,
		[ESlice.trips]: {
			...prevState?.[ESlice.trips],
			curbSideRequestedTripIds: [],
		},
	};
};
